"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MoonGlobalParameterValue = void 0;
var vue_1 = require("vue");
var TranslateMixin_1 = require("./TranslateMixin");
var constants_1 = require("../constants");
exports.MoonGlobalParameterValue = vue_1.default.component('moon-global-parameter-value', {
    props: {
        moonData: {
            type: Object,
        },
    },
    mixins: [TranslateMixin_1.TranslateMixin],
    methods: {
        value: function () {
            return this.moonData.colonyRate + "/" + this.moonData.miningRate + "/" + this.moonData.logisticsRate;
        },
        isMax: function () {
            return this.moonData.colonyRate >= constants_1.MAXIMUM_COLONY_RATE &&
                this.moonData.miningRate >= constants_1.MAXIMUM_MINING_RATE &&
                this.moonData.logisticsRate >= constants_1.MAXIMUM_LOGISTICS_RATE;
        },
    },
    template: "\n<div>\n  <div class=\"moon-tile\"></div>\n  <div>\n    <div v-if=\"isMax()\" class=\"global_params_value\">\n      <img src=\"/assets/misc/checkmark.png\" class=\"checkmark\" :alt=\"$t('Completed!')\">\n    </div>\n    <div v-else class=\"moon_params_value\">\n      {{this.value()}}\n    </div>\n  </div>\n</div>\n  ",
});
//# sourceMappingURL=MoonGlobalParameterValue.js.map